import { IAvailableOffer } from 'services/plan/types';
import { getValidProducts } from 'services/plan/utils';

/** `getValidProducts` takes an offers array, not state — passing state silently returns `[]`. */
function findUnlockUpgradeProduct(
  offers: IAvailableOffer[] | null | undefined,
  toPlanCode: string,
) {
  return (
    getValidProducts(offers).find((p) => p.plan?.code === toPlanCode) ?? null
  );
}

export default findUnlockUpgradeProduct;
